export default "__VITE_ASSET__DBrjTpBk__"